var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        id: "private-message-form",
        title: _vm.$t("message.privateMessage"),
        "show-footer": false,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.send.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                id: "email-input-group",
                label: _vm.$t("message.yourMessage"),
                "label-for": "message-input",
              },
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  id: "message-input",
                  placeholder: _vm.$t("message.onlyRepresentative"),
                  autocomplete: "off",
                  autofocus: "",
                  name: "message",
                  trim: "",
                },
                model: {
                  value: _vm.message,
                  callback: function ($$v) {
                    _vm.message = $$v
                  },
                  expression: "message",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "text-danger mt-3" }, [
                _vm._v(_vm._s(_vm.errors.first("message"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button",
            { staticClass: "primary rounded-0", attrs: { type: "submit" } },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("message.send")) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }